import dayjs from 'dayjs/esm';
import advancedFormat from 'dayjs/esm/plugin/advancedFormat';
import calendar from 'dayjs/esm/plugin/calendar';
import duration from 'dayjs/esm/plugin/duration';
import isLeapYear from 'dayjs/esm/plugin/isLeapYear';
import localeData from 'dayjs/esm/plugin/localeData';
import localizedFormat from 'dayjs/esm/plugin/localizedFormat';
import relativeTime from 'dayjs/esm/plugin/relativeTime';
import timezone from 'dayjs/esm/plugin/timezone';
import utc from 'dayjs/esm/plugin/utc';

import 'dayjs/esm/locale/af';
import 'dayjs/esm/locale/ar';
import 'dayjs/esm/locale/az';
import 'dayjs/esm/locale/bg';
import 'dayjs/esm/locale/cs';
import 'dayjs/esm/locale/de';
import 'dayjs/esm/locale/el';
import 'dayjs/esm/locale/es';
import 'dayjs/esm/locale/fa';
import 'dayjs/esm/locale/fi';
import 'dayjs/esm/locale/fr';
import 'dayjs/esm/locale/hi';
import 'dayjs/esm/locale/hu';
import 'dayjs/esm/locale/it';
import 'dayjs/esm/locale/ja';
import 'dayjs/esm/locale/ka';
import 'dayjs/esm/locale/kk';
import 'dayjs/esm/locale/ko';
import 'dayjs/esm/locale/ky';
import 'dayjs/esm/locale/nb';
import 'dayjs/esm/locale/nl';
import 'dayjs/esm/locale/pl';
import 'dayjs/esm/locale/pt';
import 'dayjs/esm/locale/ro';
import 'dayjs/esm/locale/ru';
import 'dayjs/esm/locale/sr';
import 'dayjs/esm/locale/sv';
import 'dayjs/esm/locale/tk';
import 'dayjs/esm/locale/tr';
import 'dayjs/esm/locale/uk';
import 'dayjs/esm/locale/uz';
import 'dayjs/esm/locale/zh-cn';
import 'dayjs/esm/locale/zh-tw';
import '../locales/so';
import '../locales/tt';
import '../locales/ug';

let configured = false;

export function ensureDayjsConfigured() {
    if (configured) {
        return dayjs;
    }

    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(calendar);
    dayjs.extend(localeData);
    dayjs.extend(duration);
    dayjs.extend(isLeapYear);
    dayjs.extend(advancedFormat);
    dayjs.extend(localizedFormat);
    dayjs.extend(relativeTime);

    configured = true;
    return dayjs;
}

ensureDayjsConfigured();

export { dayjs };
export default dayjs;
